import React from 'react';

function MomtheraCommonTable({
	type,
	tableHeader,
	tableBody,
	checkedItems=[],
	setCheckedItems=null,
	totalCheck,
	setTotalCheck,
	clickEvent=null,
	selectedOrder,
	setSelectedOrder,
	selectedSort,
	setSelectedSort,
}) {

	function selectAllItems(e) {
		const newSelectedItems = {};
		if (e.target.checked === true) {
			tableBody.forEach((item, idx) => {
				newSelectedItems[idx] = item;
			});
		}
		setCheckedItems(newSelectedItems);
		setTotalCheck(!totalCheck);
	}

	function selectEachItem(e, item, idx) {
		const newSelectedItems = { ...checkedItems };
		if (e.target.checked === false) {
			delete newSelectedItems[idx];
			setTotalCheck(false);
		} else {
			newSelectedItems[idx] = item;
		}
		setCheckedItems(newSelectedItems);
	}

	const covertOrder = {
		'이름' : 'name',
		'상태' : 'status',
		'주차' : 'week',
		'시작일' : 'start'
	}

	function handleClickSortBtn({name, sort}) {
		if(selectedOrder===covertOrder[name] && selectedSort===sort){
			setSelectedOrder("");
			setSelectedSort("");
		}else{
			setSelectedOrder(covertOrder[name]);
			setSelectedSort(sort);
		}
	}

	return (
		<table className='AlcoholCommonTable momthera'>
			<thead>
				<tr>
					{type==='patient' && <th className='Checkbox-Item'>
						<input
							type="checkbox"
							onChange={(e)=>selectAllItems(e)}
							checked={totalCheck}
							aria-label='Table All Checkbox'
						/>
					</th>}
					{tableHeader.map(item => (
						['이름','상태','주차','시작일'].includes(item) ? (
							<th key={item}>
								<div className='tableheader_sort_item'>
									<span>{item}</span>
									<div className='sort_btn_wrapper'>
										<button onClick={()=>handleClickSortBtn({name: item, sort: 'asc'})}>
											<div className={`tableheader_sort_item_triangle ${selectedOrder===covertOrder[item] && selectedSort==='asc' ? 'clicked' : ''}`} />
										</button>
										<button onClick={()=>handleClickSortBtn({name: item, sort: 'desc'})}>
											<div className={`tableheader_sort_item_triangle down ${selectedOrder===covertOrder[item] && selectedSort==='desc' ? 'clicked' : ''}`} />
										</button>
									</div>
								</div>
							</th>
						) : (
							<th key={item}>{item}</th>
						)
					))}
				</tr>
			</thead>
			<tbody>
				{tableBody.map((item, idx) => {
					return (
						<tr key={item["번호"] || item.ID || idx}>
							{type==="patient" && <td className='Checkbox-Item'>
								<input
									type="checkbox"
									onChange={(e)=>selectEachItem(e, item, idx)}
									checked={idx in checkedItems}
									aria-label='Table Item Checkbox'
								/>
							</td>}
							{tableHeader.map(headerItem => {
								return (
									<td
										key={headerItem}
										style={{
											cursor: `${type==="patient" ? "pointer" : "default"}`,
											fontWeight: (type==='dashboard' && idx===tableBody.length-1) ? '800' : 'normal'
										}}
										onClick={()=>type==="patient" && clickEvent(item)}
									>
										{item[headerItem]}
									</td>
								);
							})}
						</tr>
					);
				})}
			</tbody>
		</table>
	);
}

export default MomtheraCommonTable;
